import {Actions, StateChanges} from '../store/stateChanges'
import {RunStates} from '../store/runStates'
import {prettyPrint} from './featureNames'
import _ from 'lodash'

export default {
  name: 'textMixins',
  data () {
    return {}
  },
  created () {
    this.RunStates = RunStates
    this.prettyPrint = prettyPrint
  },
  computed: {
    allClasses () {
      return this.$store.state.classes
    },
    classes () {
      return this.$store.state.classes.filter(classData => classData.hasKeys())
    },
    testText () {
      return this.$store.state.testText
    },
    cv () {
      return this.$store.state.crossValidationResults.hasOwnProperty('meanAccuracy')
        ? Math.round(this.$store.state.crossValidationResults.meanAccuracy * 100) + '%'
        : 'N/A'
    },
    extractFeaturesState () {
      return this.$store.state.featuresState
    },
    updateFeaturesState () {
      return this.$store.state.updateFeaturesState
    },
    cvState () {
      return this.$store.state.cvState
    },
    classifyState () {
      return this.$store.state.classifyState
    },
    bestFeatures () {
      const state = this.$store.state
      const combinedFeatures = _.flatten(
        Object.keys(state.features)
          .filter(featureSetName => state.featureSettings[featureSetName].active)
          .map(featureSetName => {
            return this.$store.state.features[featureSetName]
              .filter(feature =>
                !state.removedFeatures[featureSetName].includes(feature.featureName))
              .map(feature => ({
                featureName: feature.featureName,
                featureType: featureSetName,
                className: feature.bestClass,
                tTest: feature.bestTtest
              }))
          })
      )
      const sortedFeatures = combinedFeatures.sort((a, b) => b.tTest - a.tTest)
      const groupedFeatures = _.groupBy(sortedFeatures, 'className')
      return groupedFeatures
    }
  },
  methods: {
    setClass ({oldText, newText}) {
      this.$store.commit(StateChanges.UPDATE_CLASS, {oldClassData: oldText, newClassData: newText})
    },
    removeClass (position) {
      if (this.allClasses.length > position) {
        this.$store.commit(StateChanges.REMOVE_CLASS, this.allClasses[position])
      }
    },
    analyze () {
      function notRunAlready (state) {
        return state !== RunStates.COMPLETE && state !== RunStates.RUNNING
      }
      if (notRunAlready(this.extractFeaturesState)) {
        this.runExtractFeatures()
      }
      if (notRunAlready(this.cvState)) {
        this.runCrossValidation()
      }
      if (this.testText && this.testText.keys && this.testText.keys.length > 0) {
        this.runClassify()
      }
    },
    setTestText (text) {
      this.$store.commit(StateChanges.SET_TEST_TEXT, text)
    },
    runExtractFeatures () {
      this.$store.dispatch(Actions.RUN_EXTRACT_FEATURES)
    },
    runCrossValidation () {
      this.$store.dispatch(Actions.RUN_CV)
    },
    runClassify () {
      this.$store.dispatch(Actions.RUN_CLASSIFICATION)
    },
    apiNameToClass (apiName) {
      return this.classes[this.apiNameToNumber(apiName)]
    },
    apiNameToNumber (apiName) {
      return +apiName.replace('class', '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/textMixins.js